// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const QuickOrder: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57 59"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M28.5 3.6c-7.1 0-13.7 2.7-18.7 7.6V2.8c0-.8-.6-1.4-1.4-1.4S7 2 7 2.8v11.6c-.3.6-.1 1.3.4 1.7.2.2.6.4.9.4h12.2c.8 0 1.4-.6 1.4-1.4s-.6-1.4-1.4-1.4H11C15.7 9 21.9 6.4 28.5 6.4c13.4 0 24.2 10.9 24.2 24.2 0 13.4-10.9 24.2-24.2 24.2-11.7 0-21.7-8.3-23.8-19.8-.3-1.5-.4-3-.4-4.5 0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4c0 1.7.2 3.3.5 5 2.4 12.8 13.5 22 26.5 22 14.9 0 27-12.1 27-27 0-14.8-12.1-26.9-27-26.9z"/><path d="M27.3 15.4c-.8 0-1.4.6-1.4 1.4v13.9c0 .5.2.9.6 1.1l12.9 8.8c.2.2.5.2.8.2.4 0 .9-.2 1.1-.6.4-.6.3-1.5-.4-1.9L28.7 30V16.8c0-.7-.6-1.4-1.4-1.4z"/></svg>;
};

export default React.memo(QuickOrder);
